export enum ManagerRoleName {
    accountManager = 'Accountmanager',
    administratiefMedewerker = 'Administratief medewerker',
    allroundFinanceMedewerker = 'Allround Finance medewerker',
    applicatiebeheerder = 'Applicatiebeheerder',
    biAnalist = 'BI Analist',
    businessAnalist = 'Business Analist',
    businessDesigner = 'Business Designer',
    businessDeveloper = 'Business Developer',
    complianceSpecialist = 'Compliance specialist',
    contractManager = 'Contract manager',
    coordinatorPolikliniek = 'Coördinator Polikliniek',
    coordinatorServicedesk = 'Coördinator Servicedesk',
    directeurDesignAndTech = 'Directeur Design & Tech',
    facturatieEnUitbetaling = 'Facturatie en uitbetaling',
    financeDeveloper = 'Finance Developer',
    kwaliteitsfunctionaris = 'Kwaliteitsfunctionaris',
    leadBackOfficeInkoper = 'Lead back office/inkoper',
    leadCompliance = 'Lead compliance',
    leadDeveloper = 'Lead Developer',
    medischSpecialist = 'Medisch Specialist',
    polimedewerkerAssistent = 'Polimedewerker/Assistent',
    polimedewerkerAssistentFundus = 'Polimedewerker/Assistent Fundus',
    productspecialist = 'Productspecialist',
    projectmanager = 'Projectmanager',
    seniorDeveloper = 'Senior Developer',
    servicedeskmedewerker = 'Servicedeskmedewerker',
    superBeheerder = 'Superbeheerder',
    supportmedewerkerFundus = 'Supportmedewerker Fundus (medior)',
    supportmedewerkerJunior = 'Supportmedewerker (junior)',
    supportmedewerkerMedior = 'Supportmedewerker (medior)',
    supportmedewerkerSenior = 'Supportmedewerker (senior)',
    systeembeheerder = 'Systeembeheerder',
    teamleadCustomerHappiness = 'Teamlead Customer Happiness',
    teamleadPolikliniek = 'Teamlead polikliniek',
    teamleadProduct = 'Teamlead Product',
    teamleadSalesEnRelatiebeheer = 'Teamlead Sales en Relatiebeheer',
    trainer = 'Trainer',
    verpleegkundige = 'Verpleegkundige',
    voorraadbeheerder = 'Voorraadbeheerder',
    zorgadministratiefMedewerker = 'Zorgadministratief medewerker',
    zorgdeclaraties = 'Zorgdeclaraties',
}
